import { useMantineTheme } from '@mantine/core';
import type { EdgeProps } from '@xyflow/react';
import { BaseEdge, Position } from '@xyflow/react';
import { getERDFlowSmoothStepPath } from '../../utils/getERDFlowSmoothStepPath';
import type { ERDFlowEdge } from '../TableEdge/TableEdge.types';

export function ColumnEdge({
	id,
	sourceX,
	sourceY,
	targetX,
	targetY,
	sourcePosition,
	targetPosition,
	markerEnd,
	data,
}: EdgeProps<ERDFlowEdge>) {
	const theme = useMantineTheme();

	const [edgePath] = getERDFlowSmoothStepPath({
		sourceX,
		sourceY,
		sourcePosition,
		targetX,
		targetY,
		targetPosition,
		position: Position.Right,
	});

	const style = {
		stroke: data?.is_highlighted
			? theme.other.getColor('border/emphasis/default')
			: theme.other.getColor('border/primary/default'),
		strokeWidth: 1,
	};

	return (
		<BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
	);
}
